import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {ViewManagerService} from "../../services/view-manager.service";
import {SessionManagerService} from "../../services/session-manager.service";
import {Space, User} from "../../model/tenants.model";
import {Level, Message} from "../../model/message.component";
import {TenantsManagerService} from "../../services/tenants-manager.service";

@Injectable({
  providedIn: 'root'
})
export class TenantsService implements OnDestroy {

  spaces: Space[] = [];
  users: User[] = [];

  space?: Space = undefined;
  user?: User = undefined;

  constructor(
    private tenantsManager: TenantsManagerService,
    private viewManager: ViewManagerService,
    private sessionManager: SessionManagerService
  ) { }

  ngOnDestroy(): void {
    this.space = undefined;
    this.user = undefined;
  }

  loadSpaces(): void {
    console.log("'SERVICE' calling load tenants");
    this.tenantsManager.spaces()
      .subscribe({
        next: (result) => {
          this.spaces = result;
        },
        error: error => {
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }

  manage(code: string) {
    console.log("'SERVICE' calling manage tenants for: " + code);
    this.tenantsManager.space(code)
      .subscribe({
        next: (result) => {
          console.log(result);
          this.space = result;
        },
        error: error => {
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });

    this.tenantsManager.users(code)
      .subscribe({
        next: (result) => {
          this.users = result;
        },
        error: error => {
          this.viewManager.displayMessage(new Message(error.error, new Level("error")))
        }
      });
  }

}
